import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Durations } from '../constants';
import { durationLength } from '../utils/duration_utils';
import { PassTypeProps } from '../props';
import { RadioInput } from '../../../ui-lottery/src/components/inputs';

const propTypes = {
  passTypes: PropTypes.arrayOf(PassTypeProps),
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default class PassTypesTable extends PureComponent {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.renderRow = this.renderRow.bind(this);
  }

  onChange(event) {
    const { value } = event.target;

    return this.props.onChange(value);
  }

  renderRow(passType) {
    const { selected } = this.props;
    const cost = `$${(parseInt(passType.price, 10) / 100000).toFixed(2)}`;
    const hasGroups = passType.groups === null ? false : Object.keys(passType.groups).length !== 0;

    return (
      <tr key={`pass-type-${passType.id}`}>
        <td>
          <RadioInput
            id={`pass-type-${passType.id}`}
            label={passType.name}
            value={passType.id}
            checked={passType.id === selected}
            onChange={this.onChange} />
        </td>
        <td>{cost}{hasGroups ? <span>&nbsp;*</span> : null}</td>
        <td>{durationLength(Durations[passType.duration])}</td>
        <td>{passType.used_for}</td>
      </tr>
    );
  }

  render() {
    const { passTypes } = this.props;

    return (
      <table className="table-no-border parkpass-pass-types-table">
        <thead>
        <tr>
          <th>Pass</th>
          <th>Cost</th>
          <th>Valid For</th>
          <th>Includes</th>
        </tr>
        </thead>
        <tbody>
        {passTypes.map(this.renderRow)}
        </tbody>
        <tfoot>
        <tr>
          <td colSpan="4"><span>*: Price does not include cost per additional attendee.</span></td>
        </tr>
        </tfoot>
      </table>
    );
  }
}

PassTypesTable.propTypes = propTypes;
